/**
 * Places the game points at that are not the game.
 *
 * One constant each, because an invite that has been regenerated is then a
 * single edit rather than a search — and a link written out three times is
 * three chances for one of them to keep pointing at the dead one.
 */

/**
 * The community server.
 *
 * `discord.gg` invites can be set to expire or to cap the number of uses; this
 * one is on the site's front door, so it has to be the permanent kind.
 */
export const DISCORD_INVITE = 'https://discord.gg/E4gdwZm8f2';
